export default __webpack_public_path__ + "static/media/GreiffCasualRf.ed92c22c.jpg";